import React from 'react';
import * as QS from 'query-string';
import router from './router';

export class Redirect extends React.Component<any, any> {
    constructor(props, context) {
        super(props, context);
    }

    public render(): React.ReactNode {
        const qsObj = QS.parse(location.search);
        if (qsObj.r) {
            requestAnimationFrame(() => {
                router.replace(qsObj.r as any);
            });
        }
        return null;
    }
}

export default Redirect;
